export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/0ed393ee82482718.png"